import React, { useEffect, useState } from "react";
import { ProjectContainer } from "../styles/projectTab";
import Xalqlar from "../assets/xalqlar.webp";
import { ProjectCard } from "./project-card";
import KoreaAvto from "../assets/koreavto.png";
import HalalCompass from "../assets/halal.png";

const Mobile = () => {
  const [opacity, setOpacity] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => {
      setOpacity(1);
    }, 200);

    return () => clearTimeout(timer);
  }, []);
  return (
    <ProjectContainer style={{ opacity, transition: "opacity 0.5s" }}>
      <ProjectCard
        link="https://play.google.com/store/apps/details?id=com.urckoreaauto.app&hl=en"
        image={KoreaAvto}
        title="Korea Avto"
        subtitle="Mobile application"
      />
      <ProjectCard
        link="https://play.google.com/store/apps/details?id=com.xalqlardostligi.app"
        image={Xalqlar}
        title="Xalqlar do'stligi (Halal food)"
        subtitle="Mobile applicationss"
      />
      <ProjectCard
        link="https://play.google.com/store/apps/details?id=com.urconhalalcompass.app&hl=enn"
        image={HalalCompass}
        title="Halal Compass"
        subtitle="Mobile application"
      />
    </ProjectContainer>
  );
};

export default Mobile;
